import type { ReportProvider, ReportFilter, ReportDataset, DatasetOptions, MetricId } from '../types'
import { engineApi } from '../../../sdk/engine.api'
import { metricsDataset } from '../engine/dataset'

const SUPPORTED_METRICS: MetricId[] = [
  'cfPending', 'cfAssigned', 'cfConfirmedToday',
  'cfNoAnswerToday', 'cfPostponed',
  'cfConversionRate', 'cfAvgConfirmTime',
]

export const ConfirmationReportProvider: ReportProvider = {
  id:                   'confirmation',
  label:                'Confirmation',
  workflowId:           'confirmation',
  supportedMetrics:     SUPPORTED_METRICS,
  supportedDimensions:  ['date', 'agent', 'team', 'status', 'outcome'],
  supportedFilters:     ['date_range', 'preset', 'teams', 'members', 'status'],
  supportedExports:     ['csv', 'excel', 'json', 'pdf'],
  defaultFilter:        { workflows: ['confirmation'] },

  async buildDataset(shop: string, filter: ReportFilter, options?: DatasetOptions): Promise<ReportDataset> {
    const data = await engineApi.metrics(shop, 'confirmation')

    const confirmed  = data.closedToday.byOutcome['cf_confirmed']  ?? 0
    const noAnswer   = data.closedToday.byOutcome['no_answer']     ?? 0
    const closedTotal = data.closedToday.total
    const convRate   = closedTotal > 0 ? confirmed / closedTotal : 0

    const metrics: Record<string, number> = {
      cfPending:        data.queued,
      cfAssigned:       data.active,
      cfPostponed:      data.postponed,
      cfConfirmedToday: confirmed,
      cfNoAnswerToday:  noAnswer,
      cfConversionRate: convRate,
      cfAvgConfirmTime: 0,
    }

    return metricsDataset('confirmation', 'confirmation', filter, metrics, undefined, options)
  },
}
